import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import FloatingWhatsApp from '../../components/feature/FloatingWhatsApp';
import CookieBanner from '../../components/feature/CookieBanner';
import BackToTop from '../../components/feature/BackToTop';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesGrid from './components/ServicesGrid';
import ProcessStepper from './components/ProcessStepper';
import DosDonts from './components/DosDonts';
import FaqAccordion from './components/FaqAccordion';
import Testimonials from './components/Testimonials';
import CoverageMap from './components/CoverageMap';
import CtaSection from './components/CtaSection';
import { injectSchema, getLocalBusinessSchema, getOrganizationSchema, getWebPageSchema } from '../../utils/seoSchema';

export default function HomePage() {
  useEffect(() => {
    // Inject Schema.org JSON-LD
    const cleanupLocalBusiness = injectSchema(getLocalBusinessSchema());
    const cleanupOrganization = injectSchema(getOrganizationSchema());
    const cleanupWebPage = injectSchema(getWebPageSchema(
      'Limpieza Post Incendio Barcelona | FIRETRAUMAS',
      'Limpieza profesional después de incendio en Barcelona. Eliminamos hollín, cenizas y olores. Coordinación con seguros. Presupuesto sin compromiso.',
      '/'
    ));

    return () => {
      cleanupLocalBusiness?.();
      cleanupOrganization?.();
      cleanupWebPage?.();
    };
  }, []);

  return (
    <div className="min-h-screen bg-bg">
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesGrid />
        <ProcessStepper />
        <DosDonts />
        <FaqAccordion />
        <Testimonials />
        <CoverageMap />
        <CtaSection />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <CookieBanner />
      <BackToTop />
    </div>
  );
}
